/** Display labels for achievement metadata (categories, tiered families, tiers). */

export const CATEGORY_LABELS = {
    account: 'Getting Started',
    activity: 'Activity',
    streak: 'Streaks',
    challenge: 'Challenges',
    social: 'Social',
};

export const CATEGORY_ORDER = ['account', 'activity', 'streak', 'challenge', 'social'];

/**
 * Names for the tiered families the API reports via `family` (see
 * `_TIERED_PREFIXES` in spud_api/achievements.py). A family missing from this
 * map falls back to a title-cased version of its key.
 */
export const FAMILY_LABELS = {
    streak: 'Streak Master',
    friends: 'Social Butterfly',
    reactions_received: 'Crowd Pleaser',
};

export const familyLabel = (family) =>
    FAMILY_LABELS[family] ||
    String(family || '')
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

/**
 * Tier names are indexed by position within a family, not by the threshold
 * itself — families start at different numbers (friends_1 vs reactions_received_5)
 * and have different lengths.
 */
export const TIER_NAMES = ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'];

export const tierName = (index) => TIER_NAMES[index] || `Tier ${index + 1}`;

/** CSS custom property for a tier ring, clamped to the highest defined tier. */
export const tierColorVar = (index) => {
    const name = TIER_NAMES[Math.min(index, TIER_NAMES.length - 1)] || TIER_NAMES[0];
    return `var(--color-tier-${name.toLowerCase()})`;
};
